export const typesPwrreset = {
   
    GET_PWRRESET_SUCCESS:'GET_PWRRESET_SUCCESS',
    GET_PWRRESET_ERROR:'GET_PWRRESET_ERROR',
    GET_PWRRESET_BEGIN:'GET_PWRRESET_BEGIN'
    
}
